import Form from "../../ui/Form";
import VehicleInfoField from "./VehicleInfoField";
import DateField from "./DateField";
import { printDate } from "../../utils/date.utils";
import {
  useCreateCustomerAttachmentMutation,
  useUpdateCustomerAttachmentMutation
} from "../../utils/customerAttachment.utils";
import { useNavigate } from "react-router-dom";
import ReceiverField from "./ReceiverField";
import ImporterInfoField from "./ImporterInfoField";
import VehicleInventoryAccessoriesAckField from "./VehicleInventoryAccessoriesAckField";

export default function InventoryForm({
  title,
  defaultValues,
  onBack,
  existInventory,
  redirectTo
}) {
  const navigate = useNavigate();

  const id = defaultValues?.id ?? null;

  let fields = [
    {
      name: "dateField",
      type: "custom",
      customComponent: DateField,
      col: { md: 12 }
    },
    {
      name: "VehicleInfoField",
      type: "custom",
      customComponent: VehicleInfoField,
      col: { md: 12 },
      others: { defaultValues }
    },
    {
      name: "ImporterInfoField",
      type: "custom",
      customComponent: ImporterInfoField,
      col: { md: 12 }
    },
    {
      name: "ReceiverField",
      type: "custom",
      customComponent: ReceiverField,
      col: { md: 12 }
    },
    {
      name: "VehicleInventoryAccessoriesAckField",
      type: "custom",
      customComponent: VehicleInventoryAccessoriesAckField,
      col: { md: 12 },
      others: { defaultValues }
    }
  ];

  // create attachement mutation
  const { loading, createCustomerAttachment } = useCreateCustomerAttachmentMutation([
    "createCustomerAttachment"
  ]);

  const { loading: updating, updateCustomerAttachment } = useUpdateCustomerAttachmentMutation([
    "updateCustomerAttachment"
  ]);

  // after create or update the page will redirect to money receipt list or customer money receipt list
  function handleRedirect() {
    if (redirectTo) {
      navigate(redirectTo);
    }
  }

  const onSubmit = async (values) => {
    let { accessories } = values;

    // filter only have value
    accessories = values?.accessories?.filter((item) => item);

    const inventoryDate = printDate(values.inventoryDate);
    const po_collector_id = values?.receiver?.name?.value ?? "";

    const formattedData = {
      ...values,
      accessories,
      inventoryDate
    };

    const strigifyData = JSON.stringify(formattedData);

    let createData = {
      type_id: 3, // inventory
      attachment: strigifyData,
      po_collector_id
    };

    // add vehicle id
    createData.stock_list_ids = values?.car?.stock_list_id ? [values?.car?.stock_list_id] : [];

    // update
    if (!!id) {
      const afterUpdated = await updateCustomerAttachment({ id, ...createData });

      if (afterUpdated?.status === 200) {
        handleRedirect();
      }
      return;
    }

    // create
    const afterCreated = await createCustomerAttachment({ ...createData });

    if (afterCreated?.status === 201) {
      handleRedirect();
    }
  };

  const isLoading = loading || updating;

  return (
    <Form
      fields={fields}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      submitbtnText={isLoading ? `${!!id ? "Editing..." : "Adding...."}` : title}
      loading={typeof isLoading === "boolean" ? isLoading : undefined}
      closebtnText={"Back"}
      onClose={onBack}
    />
  );
}
